import { DataTableNamesEnum } from "app/shared/enums/datatable-names.enum";
import { DataTableItemsPerPageEnum, DataTableStateModel } from "../dynamic-table/dynamic-table.model";

const PROBLEM_RECORDS_CASE_RECORDS_TABLE_CONFIG = [
  { name: "label.title", prop: "caseTitle", hasFilter: false, sortable: true, minWidth: 200 },
  { name: "label.case_id", prop: "caseIdentifier", hasFilter: false, sortable: true, linkedValue: true, minWidth: 200 },
  { name: "case.fields.caseStatus.label", prop: "caseStatus", hasFilter: false, sortable: true, minWidth: 200 },
  { name: "label.customer_region", prop: "customerRegion", hasFilter: false, sortable: true, minWidth: 200 },
  { name: "label.customer_name_site", prop: "customerSite", hasFilter: false, sortable: true, minWidth: 200 },
  {
    name: "label.actions",
    prop: "actionButtons", 
    maxWidth: 120,
    actionButtons: {
      delete: true,
    }
  },
]

const PROBLEM_RECORDS_CASE_RECORDS_TABLE_STATE: DataTableStateModel = {
  sortingValue: {
    prop: '',
    dir: ''
  },
  pageNumber: 1,
  showItemsPerPage: DataTableItemsPerPageEnum.ITEMS_PER_PAGE_10,
  gridName: '',
  tableType: ''
};

export {
  PROBLEM_RECORDS_CASE_RECORDS_TABLE_CONFIG,
  PROBLEM_RECORDS_CASE_RECORDS_TABLE_STATE
}
